import { List } from '@kerfjs/ui/list';
import type { SafeHtml } from 'kerfjs';

import { ChatTranscript } from './chat-transcript.js';

/** The center Chat view's transcript. Its composer is a sticky sibling in `ProjectChatView`, so the work
 *  area's Pane is the transcript's only scroller and messages scroll under the composer (HS2-Z0KFDM). */
export function ChatConversation({ emptyText }: { emptyText: string }): SafeHtml {
  // `chat-scroll-body` is the shared transcript hook the chat autoscroll finds in both
  // the rail and the center chat (init.ts).
  return (
    <List className="chat-conversation chat-scroll-body" gap="xs" controlInsets="trbl">
      <ChatTranscript emptyText={emptyText} />
    </List>
  );
}
